import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListUl, faCheckCircle, faTrashAlt, faSun, faMoon, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { getTheme, toggleTheme } from '../theme';
import './header.css';

export function LogoMark({ size = 30 }) {
  return (
    <svg className="logo-mark" width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="logo-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6d8cff" />
          <stop offset="1" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill="url(#logo-gradient)" />
      <circle cx="32" cy="32" r="17" fill="none" stroke="#fff" strokeOpacity=".3" strokeWidth="5" />
      <path d="M32 15a17 17 0 0 1 16.2 22.2" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
      <path d="M25 32.5l5 5 9-10" fill="none" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Brand() {
  return (
    <span className="brand">
      <LogoMark />
      <span className="brand__word">
        progress<span className="brand__accent">todo</span>
      </span>
    </span>
  );
}

export class ThemeToggle extends Component {
  state = { theme: getTheme() };

  toggle = () => {
    this.setState({ theme: toggleTheme() });
  }

  render() {
    const isDark = this.state.theme === 'dark';
    const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
    return (
      <button className="icon-btn icon-btn--round theme-toggle" onClick={this.toggle} title={label} aria-label={label}>
        <FontAwesomeIcon icon={isDark ? faSun : faMoon} />
      </button>
    );
  }
}

const NAV_ITEMS = [
  { to: '/', label: 'Tasks', icon: faListUl, countKey: 'current' },
  { to: '/completed', label: 'Completed', icon: faCheckCircle, countKey: 'completed' },
  { to: '/deleted', label: 'Trash', icon: faTrashAlt, countKey: 'deleted' },
];

class Header extends Component {
  state = { menuOpen: false };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleEscape);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleEscape);
  }

  handleOutsideClick = (event) => {
    if (this.state.menuOpen && this.menu && !this.menu.contains(event.target)) {
      this.setState({ menuOpen: false });
    }
  }

  handleEscape = (event) => {
    if (event.key === 'Escape' && this.state.menuOpen) this.setState({ menuOpen: false });
  }

  render() {
    const { counts = {}, currentUser, onSignOut } = this.props;
    const username = (currentUser && currentUser.username) || '';
    const email = currentUser && currentUser.attributes && currentUser.attributes.email;
    const initial = (username || '?').charAt(0).toUpperCase();

    return (
      <header className="topbar">
        <div className="topbar__inner container">
          <NavLink to="/" className="topbar__brand" aria-label="ProgressTodo home">
            <Brand />
          </NavLink>

          <nav className="nav" aria-label="Primary">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                exact
                className="nav__link"
                activeClassName="is-active"
              >
                <FontAwesomeIcon icon={item.icon} className="nav__icon" />
                <span className="nav__text">{item.label}</span>
                {counts[item.countKey] > 0 && <span className="nav__count">{counts[item.countKey]}</span>}
              </NavLink>
            ))}
          </nav>

          <div className="topbar__actions">
            <ThemeToggle />
            <div className="account" ref={(el) => { this.menu = el; }}>
              <button
                className="account__button"
                onClick={() => this.setState({ menuOpen: !this.state.menuOpen })}
                aria-haspopup="true"
                aria-expanded={this.state.menuOpen}
                title={username}
              >
                <span className="avatar">{initial}</span>
                <span className="account__name">{username}</span>
              </button>
              {this.state.menuOpen && (
                <div className="menu" role="menu">
                  <div className="menu__who">
                    <span className="avatar avatar--lg">{initial}</span>
                    <div>
                      <div className="menu__name">{username}</div>
                      {email && <div className="menu__email">{email}</div>}
                    </div>
                  </div>
                  <button className="menu__item" role="menuitem" onClick={onSignOut}>
                    <FontAwesomeIcon icon={faSignOutAlt} /> Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
